<script>
  import { auth } from '../stores/auth.js'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  let email = ''
  let password = ''
  let error = ''
  let isLoading = false

  async function handleSubmit() {
    error = ''

    // Validation
    if (!email || !password) {
      error = '請輸入 email 與密碼'
      return
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      error = 'Email 格式不正確'
      return
    }

    isLoading = true

    try {
      const result = await auth.login(email, password)

      if (result.success) {
        // Login successful
        dispatch('loginSuccess')
      } else {
        error = result.error || '登入失敗'
      }
    } catch (err) {
      error = err.message || '登入失敗，請稍後再試'
    } finally {
      isLoading = false
    }
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
  <div class="max-w-md w-full space-y-8">
    <!-- Logo and title -->
    <div class="text-center">
      <h1 class="text-4xl font-bold text-primary-600 mb-2">Wild Train</h1>
      <p class="text-gray-600">Health Tracker</p>
    </div>

    <!-- Login form -->
    <div class="bg-white rounded-lg shadow-md p-8">
      <h2 class="text-2xl font-bold text-gray-900 mb-6">登入</h2>

      {#if error}
        <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <p class="text-sm text-red-600">{error}</p>
        </div>
      {/if}

      <form on:submit|preventDefault={handleSubmit} class="space-y-4">
        <!-- Email input -->
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            id="email"
            type="email"
            bind:value={email}
            on:keypress={handleKeyPress}
            disabled={isLoading}
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            placeholder="your@email.com"
            autocomplete="email"
          />
        </div>

        <!-- Password input -->
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1">
            密碼
          </label>
          <input
            id="password"
            type="password"
            bind:value={password}
            on:keypress={handleKeyPress}
            disabled={isLoading}
            class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            placeholder="••••••••"
            autocomplete="current-password"
          />
        </div>

        <!-- Submit button -->
        <button
          type="submit"
          disabled={isLoading}
          class="w-full btn btn-primary py-3 text-base disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {#if isLoading}
            <span class="inline-flex items-center gap-2">
              <span class="animate-spin">↻</span>
              登入中...
            </span>
          {:else}
            登入
          {/if}
        </button>
      </form>
    </div>

    <!-- Footer info -->
    <div class="text-center text-sm text-gray-500">
      <p>Wild Train &copy; All Rights Reserved</p>
    </div>
  </div>
</div>
